import { useCalculatorStore } from '@/store/calculatorStore'
import Course from './Course'

const YourGrades = () => {
  const allCourses = useCalculatorStore((state) => state.courses)
  const show235 = useCalculatorStore((state) => state.show235)

  const includedCourses = show235
    ? allCourses.filter((course) => course.included && course.is235course)
    : allCourses.filter((course) => course.included)

  return (
    <>
      <h2 className="text-2xl font-bold mt-5 mb-7 mx-5 min-[1100px]:mx-0">
        Dine karakterer
      </h2>
      <div className="grid grid-cols-[1fr_212px_160px_48px] gap-6 pb-2 border-b border-warm-gray-600 text-sm font-bold">
        <div className="hidden @min-[700px]:block">Fag</div>
        <div className="hidden @min-[700px]:block">Karakter</div>
        <div className="hidden @min-[700px]:block">Eksamenskarakter</div>
        <div className="hidden @min-[700px]:block text-right">Fjern</div>
      </div>
      {includedCourses.map((course) => (
        <Course key={course.id} {...course} />
      ))}
    </>
  )
}

export default YourGrades
